import $ from 'jquery';
window.$ = window.jQuery = $;
import Cookies from 'js-cookie';
import Swiper from 'swiper/bundle';

import Plyr from 'plyr';
const player = new Plyr('#player', {
    enabled: true,
    hideControls: true,
});

function setCookie(name, value, lifetime_days) {
    var exp = new Date();
    exp.setDate(new Date().getDate() + lifetime_days);
    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
}

function getCookie(name) {
    if (document.cookie) {
        var regex = new RegExp(escape(name) + '=([^;]*)', 'gm'),
            matches = regex.exec(document.cookie);
        if (matches) {
            return matches[1];
        }
    }
}

function hideNotificationBar() {
    $("body").on('click', '.notification .close', function () {
        Cookies.set('notificationBar', 'hidden', { expires: 7, path: '/' })
        $('.notification').slideToggle(300);
    });
}
hideNotificationBar()

function popUp() {
    $("body").on('click', '.newsToggle', function () {
        $('.popUp').fadeIn(300);
    });

    $("body").on('click', '.popUp .close', function () {
        $('.popUp').fadeOut(300);
    });
}
popUp()

function mobileNav() {
    $("body").on('click', '.mobile-nav__toggle', function () {
        $(this).toggleClass('open');
        $('body').toggleClass('mobile-nav__open');
        $('#mobile-nav').slideToggle(300);
    });

    $("body").on('click', '#mobile-nav .has-mega-menu', function () {
        $(this).find('.mega-menu').slideToggle(300);
        $(this).toggleClass('open');
    });
}
mobileNav()


function toggleItem() {
    $(document).ready(function () {
        if ($('.software .toggle-item').hasClass('active')) {
            $('.software .active').find('.hidden').slideToggle(300);
            $('.software .active').find('.angle').css('transform', 'rotate(180deg)');
        }
    });

    $("body").on('click', '.toggle-item', function () {
        $(this).toggleClass("active");
        if ($(this).hasClass('active')) {
            $(this).find('.hidden').slideToggle(300);
            $(this).find('.angle').css('transform', 'rotate(180deg)');
        } else {
            $(this).find('.hidden').slideToggle(300);
            $(this).find('.angle').css('transform', 'rotate(0deg)');
        }
    });
}
toggleItem()


var swiper = new Swiper(".functionSwiper", {
    navigation: {
        nextEl: '.nextFunction',
    },
    pagination: {
        el: ".function-pagination",
        clickable: true,
        paginationType: "custom",
        renderBullet: function (index, className) {
            var icons = [];
            var names = [];
            $(".swiper-wrapper .swiper-slide").each(function (i) {
                icons.push($(this).data("image"));
                names.push($(this).data("name"));
            });
            var index = (index);
            var text = '<span class="relative group [&.swiper-pagination-bullet-active]:bg-primary-600 h-10 w-10 lg:h-12 lg:w-12 p-2 bg-primary flex items-center justify-center cursor-pointer rounded-full hover:bg-primary-600 duration-300 ' + className + '">';
            text += '<span class="opacity-0 group-hover:opacity-100 absolute font-medium text-primary-500 bg-white -translate-y-full -mt-8 p-2 text-xs whitespace-nowrap rounded shadow-sm">' + names[index] + '</span>';
            text += '<img src="' + icons[index] + '" class="max-h-5 lg:max-h-7 " alt="' + names[index] + '">';
            text += "</span>";
            return text;
        },
    },
});

var swiper = new Swiper(".referenceSwiper", {
    slidesPerView: 3,
    spaceBetween: 32,
    speed: 300,
    loop: true,
    pagination: {
        el: ".reference-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.nextRef',
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        "@1.50": {
            slidesPerView: 3,
            spaceBetween: 32,
        },
    },
});

var related = new Swiper(".relatedSwiper", {
    slidesPerView: 3,
    spaceBetween: 32,
    speed: 600,
    fade: true,
    loop: true,
    pagination: {
        el: ".reference-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.nextRelated',
        prevEl: '.prevRelated',
    },
    breakpoints: {
        "@0.00": {
            slidesPerView: 1,
            spaceBetween: 32,
        },
        "@0.75": {
            slidesPerView: 2,
            spaceBetween: 23,
        },
        "@1.00": {
            slidesPerView: 2,
            spaceBetween: 32,
        },
        "@1.50": {
            slidesPerView: 3,
            spaceBetween: 32,
        },
    },
});

function functionTabs() {
    $("body").on('click', '.functions ul li', function () {
        $('.functions .active').removeClass('active');
        $(this).addClass('active');
        var item = $(this).attr('function');
        console.log('#' + item);
        $('.functions .visible').removeClass('visible').addClass('hidden');
        $('#' + item).removeClass('hidden').addClass('visible');
    });
}
functionTabs()

function productFunctionTabs() {
    // On mobile scroll tab to left.
    jQuery(document).ready(function () {
        var scrollArea = jQuery('.nav-tabs');
        var toScroll = jQuery('.nav-tabs .text-tab');
        function myScroll() {
            toScroll.each(function () {
                var self = jQuery(this);
                jQuery(this).css('cursor', 'pointer');
                jQuery(this).on('click', function () {
                    var leftOffset = self.offset().left - scrollArea.offset().left + scrollArea.scrollLeft();
                    scrollArea.animate({ scrollLeft: leftOffset });
                });
            });
        };
        myScroll();
    });
}
productFunctionTabs()